"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = void 0;
class Widget {
    constructor() {
        this._alreadyRendered = false;
        this.renderOnce = false;
        this.widgets = [];
    }
    set parentWidget(value) {
        this._parentWidget = value;
    }
    get parentWidget() {
        return this._parentWidget;
    }
    clear() {
        this.renderBody.innerHTML = "";
    }
    render() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._alreadyRendered && this.shouldRender()) {
                if (this.onRender != null) {
                    yield this.onRender();
                }
                for (let subWidget of this.widgets) {
                    yield subWidget.render();
                    this.renderBody.appendChild(subWidget.renderBody);
                }
            }
            if (this.renderOnce) {
                if (!this._alreadyRendered)
                    this._alreadyRendered = true;
            }
        });
    }
}
exports.Widget = Widget;
//# sourceMappingURL=Widget.js.map